import React from "react";
import { Provider } from "react-redux";
import { OloAppBase } from "./OloAppBase";
import { OnlineOrdering } from "components/online_ordering/OnlineOrdering";
import type { OloStore } from "reducers/online_ordering/onlineOrdering";

export interface OloAppProps {
  store: OloStore;
}

export const OloApp = ({ store }: OloAppProps) => {
  return (
    <Provider store={store}>
      <OloAppBase identifyTrackingMessage="Access OLO Page">
        <OnlineOrdering />
      </OloAppBase>
    </Provider>
  );
};

export default OloApp;
